import { InsuranceAddress } from "./InsuranceAddress";

export enum BillingAddressType {
  Property = 1,
  Mailing = 2,
  Different = 3,
}

export class PaymentMethod {
  creditCard = true;
  nameOnCard = "";
  cardNumber = "";
  cvv = "";
  expDateMonth = "";
  expDateYear = "";
  routingNumber = "";
  accountNumber = "";
  confirmAccountNumber = "";
  billingDay = 1;
  billingAddressType = BillingAddressType.Property;
  billingAddress = new InsuranceAddress();
}
